import React, { useContext } from 'react';
import classNames from 'classnames';
import EnterpriseNavigation from '../../components/EnterpriseNavigation';
import EnterpriseBrandingWrapper from 'components/EnterpriseBrandingWrapper';
import EnterpriseContext from '../../providers/Enterprise/Enterprise.context';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { BUSINESS_ROUTE } from 'data/global';
import { Navigate } from 'react-router-dom';

import './Branding.styles.scss';

type BrandingProps = {
  className?: string;
};

const Branding: React.FC<BrandingProps> = (props) => {
  const { className } = props;

  const { isOfficeManager } = useContext(CurrentUserContext);
  const { enterprise, updateEnterprise } = useContext(EnterpriseContext);

  const classes = classNames('branding', className);

  if (isOfficeManager) return <Navigate to={BUSINESS_ROUTE} replace />;

  return (
    <div className={classes}>
      <EnterpriseNavigation />
      <EnterpriseBrandingWrapper
        enterprise={enterprise}
        updateEnterprise={updateEnterprise}
      />
    </div>
  );
};

export default Branding;
